import React from 'react'
import {timeAgo, sanitizeDateTime} from '../timeFunctions/timeFns'

import {siteLastContact} from '../database/apiv2SiteAccessor'
import './Tooltip.css'

export const GreenCheck = function(props) {
    return  <div className="dota default-dot green-dota" key="grchk">&#10004;</div>;
};
export const GreenNonAdv = function(props) {
    return  <div className="dota default-dot green-dota" key="grnad">
        <div className="heavy-dotx">&#129180;</div></div>;
};
export const RedStop = function(props) {
    return  <div className="dota default-dot red-dota" key="redstp">
        <div className="heavy-dotx">&#129180;</div></div>;
};
export const YellowCheck = function(props) {
    return  <div className="dota default-dot yellow-dota" key="yechk">&#10004;</div>;
};

export const RedCheck = function(props) {
    return  <div className="dota default-dot red-dota" key="rdchk">&#10004;</div>;
};
export const BlackCheck = function(props) {
    return  <div className="dota default-dot black-dota" key="blchk">&#10004;</div>;
}
export const GreenDot = function(dt, fmt, size) {
    return aToolTipDot (size, "dota green-gradient", dt, fmt);
};
  
export const YellowDot = function(dt, fmt, size) {
    return aToolTipDot(size, "dota yellow-gradient", dt, fmt);
};
  
export const RedDot = function(dt, fmt, size) {
    return aToolTipDot(size, "dota red-gradient", dt, fmt);
};

export function aDot (size, style){
    return <span className={size+" "+style}></span>
}
export function coldDot (props) {
    return <div className="dota default-dot" key="lowtemp">&#10004;</div>;
}
function aToolTipDot (size, style, dt, fmt) {
    return <div className={size+" "+style}>&nbsp;
     <span className="missing">{new Intl.DateTimeFormat('default', fmt).format(dt)}</span>
    </div>
}

export function ContactDaysAgo(props) {
    const lastContact = sanitizeLastContact(props);
    if (lastContact.getTime && !isNaN(lastContact.getTime())) {
        const age = timeAgo(lastContact)
        return Math.floor(age/86400000)
    }
    return 365*2    
}
// 0 is bad, 1 moderate, 2 good. takes {lastContact: xxxxx}
export const ContactQuality = function(props) {
    const qualities = [172800000, 86400000, 0]  // 2d, 1d, now
    const age = ContactAge(props);
    return qualities.findIndex((element) => age > element)
}

export const ContactAge = function (props) {
    let age = 172800001;       //canonically ancient
    const lastContact = sanitizeLastContact(props);
    if (lastContact.getTime && !isNaN(lastContact.getTime())) {
        age = timeAgo(lastContact);
    }
    return age;
}

export const ContactStyle = function (interval) {
    return Math.min(Math.floor(interval / 86400000), 2);      // 86400 =seconds per day
}

function sanitizeLastContact(props) {
    const site = props?.site;
    const lc = site ? siteLastContact(site) : props?.lastContact;
    return lc ? sanitizeDateTime(lc) : new Date(2020, 0, 1)
}    

export const ContactCheck = function(props) {
    const tt_time_fmt = {
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric',
      };
    const interval = ContactAge (props);
    const lc = sanitizeLastContact (props);
    const dotsize = props.dotsize ? props.dotsize : "default-dot";
    if (interval > 172800000)      // 2 days in milliseconds
        return RedDot(lc, tt_time_fmt, dotsize);
    if (interval > 86400000)    // 1 day
        return YellowDot(lc, tt_time_fmt, dotsize);
    return GreenDot(lc, tt_time_fmt, dotsize);
}

export const SignalCheck = function(props) {
    if (props.signal <= 30)
        return RedCheck();
    else if (props.signal <= 60)
        return (YellowCheck());
    else
        return GreenCheck();
}

const TWO_WEEKS = 1209600000;       // = 14 * 24 * 3600 * 1000
export const ContactDot = function(props) {
    const interval = ContactAge (props);
    const dotsize = props.dotsize ? props.dotsize : "default-dot";
    if (interval > TWO_WEEKS)
        return aDot(dotsize, "dotb wg-black")
    if (interval > 172800000)      // 2 days ms
        return aDot(dotsize, "dotb wg-red");
    if (interval > 86400000)
        return aDot(dotsize, "dotb wg-yellow");
    return aDot(dotsize, "dotb wg-green");      //aDot(dotsize, "dota green-gradient") 
}

function intervalToIndicator (interval) {
    if (interval > TWO_WEEKS)
        return <BlackCheck />
    if (interval > 172800000)      // 2 days in milliseconds
        return <RedCheck />;
    if (interval > 86400000)    // 1 day
        return <YellowCheck />;
    return <GreenCheck /> // GreenCheck();
}

export const ContactChecked = function(props) {
    const interval = ContactAge (props);
    return intervalToIndicator(interval);
}

export function ContactIndicator (datetime) {
    const interval = timeAgo(datetime);
    return intervalToIndicator (interval);
}
